<template>
    <div>
      <h1>My rides</h1>
    </div>
  </template>
  
  <script setup>
  </script>